<!-- GameSetup.vue -->
<script setup>
import { ref } from 'vue'
import { useGameStore } from '@/store/game'
import GameRulesModal from './GameRulesModal.vue'
import { CATCH_REGION_NAMES } from '@/constants/regionConstants'

const gameStore = useGameStore()
const showRules = ref(false)
const playerName = ref('')
const ranchName = ref('')
const homeRegion = ref('region1') 
const formError = ref('')

const handleSubmit = () => {
 if (!playerName.value || !ranchName.value) {
   formError.value = 'Please fill in all fields'
   return
 }
 showRules.value = true
}

const startGame = () => {
 gameStore.initializeGame(
   playerName.value,
   ranchName.value, 
   homeRegion.value
 )
}
</script>

<template>
 <div class="min-h-screen flex items-center justify-center bg-gray-100">
   <div class="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
     <h2 class="text-2xl font-bold mb-6 text-center">Setup Your Ranch</h2>
     
     <div class="space-y-4">
       <div>
         <label class="block text-sm font-medium text-gray-700 mb-1">
           Your Name
         </label>
         <input 
           v-model="playerName"
           class="w-full p-2 border rounded-md"
           placeholder="Enter your name"
         />
       </div>

       <div>
         <label class="block text-sm font-medium text-gray-700 mb-1">
           Ranch Name
         </label>
         <input 
           v-model="ranchName"
           class="w-full p-2 border rounded-md"
           placeholder="Enter ranch name"
         />
       </div>

       <div>
         <label class="block text-sm font-medium text-gray-700 mb-1">
           Home Region
         </label>
         <select 
           v-model="homeRegion"
           class="w-full p-2 border rounded-md bg-white"
         >
           <option 
             v-for="(name, region) in CATCH_REGION_NAMES" 
             :key="region"
             :value="region"
           >
             {{ name }}
           </option>
         </select>
       </div>

       <div v-if="formError" class="text-red-500 text-sm">
         {{ formError }}
       </div>

       <button 
         @click="handleSubmit"
         class="w-full py-2 px-4 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition"
       >
         Start Game
       </button>
     </div>
   </div>

   <GameRulesModal 
     v-if="showRules"
     @close="startGame"
   />
 </div>
</template>